// Google Analytics 4 event helper. The tag itself is installed by the HTML
// shell (apply-hosting-engine src/views/template.ejs in every deployment,
// src/html/index.html for local dev), which configures GA on production
// hosts only and never for automated browsers; `window.gtag` is a queue stub
// otherwise, so calling it is always safe and events simply go nowhere when
// GA is off. Browser-only, deliberately NOT persisted to tracking_event: the
// user actions reported here already have their own Segment / tracking_event
// records under their own names.
export const gaEvent = (name, params = {}) => {
  try {
    if (typeof window === 'undefined') return;
    // Mirror for e2e / debugging — every call, sent or not (same contract
    // as Volt `window.__tentoGaEvents` and the marketing site).
    var list = (window.__tentoGaEvents = window.__tentoGaEvents || []);
    if (list.length >= 200) list.shift();
    list.push({ name: name, params: params });
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  } catch (e) {
    // analytics must never impact the flow
  }
};

/**
 * First-touch utm_* (tento_attr cookie) as GA4 user properties, so a cohort
 * can be cut by the campaign that FIRST brought the person in whichever
 * later session the application happens. Called from index.tsx right after
 * captureAttribution(); lands in the dataLayer after the shell's `config`,
 * before any flow event. Same four names as Volt and tento.com.
 */
export const setGaUserProperties = (attribution) => {
  try {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    var a = attribution && typeof attribution === 'object' ? attribution : {};
    var pick = function (k) {
      var v = a['utm_' + k];
      return typeof v === 'string' && v !== '' ? v.slice(0, 100).toLowerCase() : '(none)';
    };
    window.gtag('set', 'user_properties', {
      first_touch_source: pick('source'),
      first_touch_medium: pick('medium'),
      first_touch_campaign: pick('campaign'),
      first_touch_content: pick('content'),
    });
  } catch (e) {
    // analytics must never impact the flow
  }
};

/**
 * Any Tento address — every @tento.co / @tento.com mailbox is staff, so the
 * whole domain is excluded rather than a name list that would go stale as
 * people join. Sub-domains do not match. Plus-addressing is irrelevant here
 * (we only look at the domain), so mateusz+e2e@tento.co is covered too.
 *
 * Deliberately code, not GA4's "Define internal traffic": that matches on IP
 * address and caps at 10 rules, so it cannot follow remote staff.
 * Keep in sync with volt-portal `src/lib/googleAnalytics.ts`.
 */
const STAFF_DOMAINS = ['tento.co', 'tento.com'];

export const isStaffEmail = (email) => {
  if (!email || typeof email !== 'string') return false;
  const parts = email.trim().toLowerCase().split('@');
  if (parts.length !== 2 || !parts[0]) return false;
  return STAFF_DOMAINS.indexOf(parts[1]) !== -1;
};

/**
 * GA4's documented per-property opt-out: once this global is true, gtag.js
 * sends nothing, even though the shell installed the tag before we knew who
 * was signing in. Called from Auth0LoggedInSetState once the id token resolves.
 */
export const disableGaForStaff = (email) => {
  try {
    if (!isStaffEmail(email)) return false;
    const id = typeof window !== 'undefined' ? window.__tentoGaId : '';
    if (id) window['ga-disable-' + id] = true;
    return true;
  } catch (e) {
    return false;
  }
};
